import React, { useState, useEffect } from 'react';

function RelatorioFiltroModal({ show, onClose, onConfirm, relatorio, programas = [] }) {
  const [selectedPrograma, setSelectedPrograma] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (show) {
      setSelectedPrograma('');
      setError(null);
    }
  }, [show]);

  const handleConfirm = (e) => {
    e.preventDefault();
    if (!selectedPrograma) {
      setError('Selecione um programa.');
      return;
    }
    onConfirm({ tipo: relatorio, idPrograma: selectedPrograma });
    onClose();
  };

  if (!show) return null;

  return (
    <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1055, position: 'fixed', inset: 0, overflowY: 'auto' }}>
      <div className="modal-dialog modal-sm modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header bg-success text-white" style={{ padding: '0.35rem 1rem' }}>
            <h6 className="modal-title mb-0 small">
              <i className="bi bi-funnel me-2"></i>Filtro - {relatorio}
            </h6>
            <button type="button" className="btn-close btn-close-white" onClick={onClose}></button>
          </div>
          <form onSubmit={handleConfirm}>
            <div className="modal-body">
              <div className="mb-3">
                <label className="form-label">Programa *</label>
                <select className="form-select form-select-sm" value={selectedPrograma} onChange={e => setSelectedPrograma(e.target.value)} required>
                  <option value="">Selecione...</option>
                  {programas.map(p => (
                    <option key={p.id} value={p.id}>{p.descricao}</option>
                  ))}
                </select>
              </div>
              {error && <div className="alert alert-danger small py-1">{error}</div>}
            </div>
            <div className="modal-footer" style={{ padding: '0.4rem 1rem' }}>
              <button type="button" className="btn btn-secondary btn-sm" onClick={onClose}>Cancelar</button>
              <button type="submit" className="btn btn-success btn-sm" disabled={loading || !selectedPrograma}>Gerar</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default RelatorioFiltroModal;
